import {
  FETCH_BOOKINGS,
  UPDATE_BOOKING_CANCELED,
  UPDATE_BOOKING_CHECKED,
  UPDATE_BOOKING_VISITED,
} from "../constants/bookings";
import { Filter } from "../types";

export function fetchBookings(doctorId: number, filters?: Filter) {
  return {
    type: FETCH_BOOKINGS,
    api: true,
    payload: {
      method: "GET",
      url: `/doctor/${doctorId}/bookings`,
      params: filters,
    },
  };
}

export function setBookingChecked(bookingId: number, calendarAccessToken?: string) {
  return {
    type: UPDATE_BOOKING_CHECKED,
    api: true,
    payload: {
      method: "PATCH",
      url: `/bookings/${bookingId}`,
      data: { checked: true, calendarAccessToken },
    },
    data: { bookingId },
  };
}

export function setBookingCanceled(bookingId: number, cancelDescription: string, officeId?: number | string) {
  return {
    type: UPDATE_BOOKING_CANCELED,
    api: true,
    payload: {
      method: "PATCH",
      url: `/bookings/${bookingId}`,
      data: { canceled: true, cancelDescription },
    },
    data: { bookingId, officeId },
  };
}

export function setBookingVisited(bookingId: number, visited: boolean) {
  return {
    type: UPDATE_BOOKING_VISITED,
    api: true,
    payload: {
      method: "PATCH",
      url: `/bookings/${bookingId}`,
      data: { visited: visited },
    },
    data: { bookingId },
  };
}
